import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { StepTitle, NavButtons, UploadSlot } from "@/components/onboard/ui";
import { toast } from "sonner";

const COMPANY_DOCS = [["mc_authority", "MC Authority Certificate"], ["insurance", "Insurance Certificate"], ["noa", "NOA (Notice of Assignment)"], ["owner_cdl", "Owner's CDL or DL"]];
const asSlot = (url, name) => (url ? { url, name } : null);

export function StepDocuments({ token, state, onSaved, onBack }) {
  const prev = state.wizard.documents || {};
  const n = state.total_trucks;
  const [docs, setDocs] = useState(() => Object.fromEntries(COMPANY_DOCS.map(([k, l]) => [k, asSlot(prev[k], l)])));
  const [trucks, setTrucks] = useState(() => Array.from({ length: n }, (_, i) => ({
    truck_photo: asSlot(prev.trucks?.[i]?.truck_photo, `Truck ${i + 1}`), trailer_photo: asSlot(prev.trucks?.[i]?.trailer_photo, `Trailer ${i + 1}`),
  })));
  const [loading, setLoading] = useState(false);
  const missing = COMPANY_DOCS.filter(([k]) => !docs[k]).length + trucks.reduce((s, t) => s + (t.truck_photo ? 0 : 1) + (t.trailer_photo ? 0 : 1), 0);

  const save = async () => {
    setLoading(true);
    try {
      const data = { ...Object.fromEntries(COMPANY_DOCS.map(([k]) => [k, docs[k]?.url])), trucks: trucks.map((t) => ({ truck_photo: t.truck_photo?.url, trailer_photo: t.trailer_photo?.url })) };
      const { data: s } = await api.post(`/onboard/${token}/save`, { step: "documents", data });
      onSaved(s);
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <StepTitle kicker="Step 4 · Documents" title="Upload Your Documents" sub={`Company paperwork plus a truck and trailer photo for each of your ${n} truck${n > 1 ? "s" : ""}.`} />
      <div className="grid sm:grid-cols-2 gap-3">
        {COMPANY_DOCS.map(([k, l]) => <UploadSlot key={k} token={token} label={l} value={docs[k]} onChange={(v) => setDocs({ ...docs, [k]: v })} testid={`ob-doc-${k}`} />)}
      </div>
      <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-white/50 mt-8 mb-3">Truck & Trailer Photos</p>
      <div className="space-y-3">
        {trucks.map((t, i) => (
          <div key={i} className="grid sm:grid-cols-[90px_1fr_1fr] gap-3 items-center">
            <span className="text-sm font-heading font-bold text-white/70">Truck {i + 1}</span>
            <UploadSlot token={token} label={`Truck ${i + 1} Photo`} value={t.truck_photo} onChange={(v) => setTrucks(trucks.map((x, j) => (j === i ? { ...x, truck_photo: v } : x)))} testid={`ob-truck-photo-${i}`} />
            <UploadSlot token={token} label={`Trailer ${i + 1} Photo`} value={t.trailer_photo} onChange={(v) => setTrucks(trucks.map((x, j) => (j === i ? { ...x, trailer_photo: v } : x)))} testid={`ob-trailer-photo-${i}`} />
          </div>
        ))}
      </div>
      <NavButtons onBack={onBack} onNext={save} loading={loading} disabled={missing > 0} nextLabel={missing ? `${missing} Upload${missing > 1 ? "s" : ""} Left` : "Save & Continue"} />
    </div>
  );
}
